﻿export * from './tabla.component';
